import { Repository } from "./adapters/repository";

import * as retrieveNotifications from "./useCases/retrieveNotifications";
import * as retrieveUnReadNotificationsNbr from "./useCases/retrieveUnReadNotificationsNbr";
import * as markNotificationsAsRead from "./useCases/markNotificationsAsRead";

enum UseCases {
  retrieveNotifications = "retrieveNotifications",
  retrieveUnReadNotificationsNbr = "retrieveUnReadNotificationsNbr",
  markNotificationsAsRead = "markNotificationsAsRead",
}

interface Core {
  [UseCases.retrieveNotifications]: retrieveNotifications.Interactor;
  [UseCases.retrieveUnReadNotificationsNbr]: retrieveUnReadNotificationsNbr.Interactor;
  [UseCases.markNotificationsAsRead]: markNotificationsAsRead.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveNotifications]: retrieveNotifications.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveUnReadNotificationsNbr]:
      retrieveUnReadNotificationsNbr.createInteractor(dependencies.repository),
    [UseCases.markNotificationsAsRead]:
      markNotificationsAsRead.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
